<template>
  <el-row class="login">
    <el-col class="bg-purple-light" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
      <div>
        <div class="login_input">
          <el-row>
            <el-col>
              <h1 class="title3">Жолоочийн систем</h1><br>
              <h3 class="title4">Тавтай морилно уу</h3>
            </el-col>
          </el-row>
          <el-form class="m-t-40" :model="loginForm" label-position="top" ref="dynamicValidateForm" label-width="120px">
            <el-form-item prop="phone1" :rules="[
            { required: true, message: 'Бүртгэлийн дугаар хоосон байна.', trigger: 'blur' }]">
              <el-input v-model="loginForm.phone1" clearable placeholder="Бүртгэлийн дугаар">
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="button1" type="primary" @click="submitForm('dynamicValidateForm')">Нэвтрэх</el-button>
            </el-form-item>
            <!-- <div>
              <el-button class="forget_pass_link" type="text" @click="forgetpass()">Нууц үгээ мартсан </el-button>
            </div> -->
          </el-form>
        </div>
      </div>
    </el-col>
    <loader-item :isLoader='this.$root.fullscreenLoading'></loader-item>
  </el-row>
</template>

<script>
import LoaderItem from '@/components/loader/loader-item.vue'
import services from '@/helpers/services.js'
export default {
  components: {
    LoaderItem
  },
  data () {
    return {
      loginForm: {
        phone1: '',
        password: '95555222'
      }
    }
  },
  methods: {
    forgetpass () {
      this.$router.push({
        name: 'resetPassword'
      })
    },
    adduser () {
      this.$router.push({
        name: 'regUser'
      })
    },
    submitForm (formName) {
      this.$root.fullscreenLoading = true

      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('Form validation error!')
          this.$root.fullscreenLoading = false
          return
        }

        this.$store.dispatch('signin', this.loginForm)
          .then(response => {
            if (response && response.token) {
              this.$store.dispatch('setToken', response.token)
              this.$store.dispatch('authUserLoginPage', {
                token: response.token,
                user: response.user
              })
              this.$store.dispatch('userAdd', response.user)
              if (response.permissions) {
                this.$store.dispatch('addRoleLoginPage', response.permissions)
              }

              this.$router.push('/home')
            } else {
              this.$message.error('Нэвтрэхэд алдаа гарлаа!')
            }

            this.$root.fullscreenLoading = false
          })
          .catch(error => {
            console.error('Login error:', error)
            this.$message.error(error.response?.data?.message || 'Системийн алдаа гарлаа.')
            this.$root.fullscreenLoading = false
          })
      })
    },
    padd () {
      const jishee = {
        uuid: JSON.parse(localStorage.getItem('userId'))
      }
      services.getUserById(jishee)
        .then((response) => {
          console.log(response)
          // this.$root.logged_in_user_name = response.result.first_name
          this.$store.dispatch('userAdd', response.result.first_name)
        })
    }
  }
}

</script>
